import { Switch, SwitchProps } from '@vechaiui/react';
import { useField } from 'formik';

import Field from '#/components/forms/Field';
import { ContainerPacking } from '#/__generated__/graphql/graphql';

const ContainerPackingSwitch: React.FC<ContainerPackingSwitchProps> = ({
  onChange,
  leftText,
  rightText,
  value,
  ...props
}) => {
  const handleChange = (ev: React.ChangeEvent<HTMLInputElement>) => {
    onChange?.(ev.target.checked ? (ev.target.value as ContainerPacking) : undefined);
  };

  return (
    <label className="inline-flex items-center gap-4">
      {!!leftText && <span>{leftText}</span>}
      <Switch
        size="lg"
        {...props}
        checked={value === ContainerPacking.LessThanContainerLoad}
        onChange={handleChange}
        value={ContainerPacking.LessThanContainerLoad}
      />
      {!!rightText && <span>{rightText}</span>}
    </label>
  );
};
export type ContainerPackingSwitchProps = SwitchProps & {
  onChange?: (value?: ContainerPacking) => void;
  leftText?: string;
  rightText?: string;
  value?: ContainerPacking;
};

export const ContainerPackingSwitchFormik: React.FC<ContainerPackingSwitchFormikProps> = ({
  name,
  ...props
}) => {
  const [field, meta, helper] = useField(name);

  return (
    <Field name={name}>
      <ContainerPackingSwitch {...field} onChange={helper.setValue} {...props} />
    </Field>
  );
};
export type ContainerPackingSwitchFormikProps = ContainerPackingSwitchProps & {
  name: string;
};

export default ContainerPackingSwitch;
